import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ChatWidget } from "@/components/chat/ChatWidget";

export const openChat = () => window.dispatchEvent(new Event("cm-open-chat"));

// Site-wide: polls unread admin replies, pops an in-app alert (+vibration) and broadcasts the count.
// Outside the editor it also hosts a button-less chat panel opened by alerts / notification taps.
export default function ChatAlerts() {
  const { user } = useAuth() || {};
  const { pathname, search } = useLocation();
  const last = useRef(null);
  const active = !!user && user.role !== "admin";

  useEffect(() => {
    if (!active) return undefined;
    const tick = async () => {
      try {
        const { count } = await api.chatUnread();
        window.dispatchEvent(new CustomEvent("cm-chat-unread", { detail: count }));
        if (last.current !== null && count > last.current) {
          navigator.vibrate?.([120, 60, 120]);
          toast.message("Support replied to your message", { action: { label: "Open chat", onClick: openChat }, duration: 8000 });
        }
        last.current = count;
      } catch { /* offline */ }
    };
    tick();
    const iv = setInterval(tick, 20000);
    const onVis = () => document.visibilityState === "visible" && tick();
    document.addEventListener("visibilitychange", onVis);
    const onSw = (e) => e.data?.type === "open-chat" && openChat();
    navigator.serviceWorker?.addEventListener("message", onSw);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); navigator.serviceWorker?.removeEventListener("message", onSw); };
  }, [active]);

  useEffect(() => { if (active && new URLSearchParams(search).get("chat") === "1") setTimeout(openChat, 300); }, [active, search]);

  if (!active || pathname.startsWith("/editor")) return null;
  return <ChatWidget buttonless />;
}
